<template>
  <v-dialog v-model="accountingProductManageDialog" max-width="1000" persistent scrollable>
    <v-form @submit.prevent="save()" ref="form" :lazy-validation="true" :disabled="isLoading">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center blue white--text py-2">
          {{ $t('accounting_product.add') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="p-5">
          <span class="acc-header pl-5"> {{ $t('account.setting_accounting') }} </span>
          <v-row class="mt-1">
            <v-col cols="6" class="py-1 pl-4">
              <span>
                {{ $t('accounting_product.type_of_list') }}
                <span class="red--text">*</span>
              </span>
              <v-select v-model="formData.type" :items="typeOptions" item-text="name" item-value="value" outlined dense
                hide-details :placeholder="$t('accounting_product.type_of_list')" :rules="[rules.required]"
                :no-data-text="$t('noinfo')">
                <template v-slot:selection="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:item="{ item }">
                  {{ item.name }}
                </template>
              </v-select>
            </v-col>
            <v-col cols="6" class="py-1 pl-4" v-if="formData.type == 'facility'">
              <span>
                {{ $t('accounting_product.facility_type') }}
                <span class="red--text">*</span>
              </span>
              <v-select v-model="formData.subType" :items="subTypeOptions" item-text="name" item-value="value" outlined
                dense hide-details :placeholder="$t('accounting_product.facility_type')" :rules="[rules.required]"
                :no-data-text="$t('noinfo')">
                <template v-slot:selection="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:item="{ item }">
                  {{ item.name }}
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="py-1 pl-4">
              <span>
                {{ $t('accounting_product.list_name') }}
                <span class="red--text">*</span>
              </span>
              <v-text-field v-model="formData.name" outlined dense hide-details
                :placeholder="$t('accounting_product.list_name')" :rules="[rules.required]">
              </v-text-field>
            </v-col>
            <v-col cols="6" class="py-1 pl-4">
              <span>
                {{ $t('accounting_product.unit') }}
                <span class="red--text">*</span>
              </span>
              <v-text-field v-model="formData.unit" outlined dense hide-details
                :placeholder="$t('accounting_product.unit')" :rules="[rules.required]">
              </v-text-field>
            </v-col>
            <v-col cols="6" class="py-1 pl-4">
              <span>{{ $t('accounting_product.withholding_tax') }}</span>
              <v-select v-model="formData.whtPercent" :items="taxWithheldOptions" item-text="name" item-value="value"
                outlined dense hide-details :placeholder="$t('accounting_product.withholding_tax')"
                :no-data-text="$t('noinfo')">
              </v-select>
            </v-col>
            <v-col cols="6" class="py-1 pl-4">
              <span>{{ $t('product.vat') }}</span>
              <v-select v-model="formData.sellVatType" :items="vatOptions" item-text="name" item-value="value" outlined
                dense hide-details :placeholder="$t('product.vat')" :no-data-text="$t('noinfo')">
              </v-select>
            </v-col>
          </v-row>
          <v-expansion-panels flat multiple v-model="panel" class="mt-5">
            <v-expansion-panel>
              <v-expansion-panel-header class="acc-header">{{ $t('account.setting_accounting_show')
                }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="px-5 pb-5">
                  <v-col cols="12" class="pt-0 pb-0"><b> {{ $t('invoice.title') }}</b></v-col>
                  <v-col cols="6" class="py-1 ps-4">
                    <v-checkbox class="mt-2" v-model="formData.isGroupingItems" :disabled="formData.isShowDetail"
                      outlined :label="$t('invoice.combine_into_one_list')" hide-details>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="6" class="py-1 ps-4">
                    <v-checkbox class="mt-2" v-model="formData.isShowDetail" :disabled="formData.isGroupingItems"
                      outlined :label="$t('invoice.show_detail_in_invoice')" hide-details>
                    </v-checkbox>
                  </v-col>
                  <template v-if="formData.isShowDetail && formData.type == 'facility'">
                    <v-col cols="6"> </v-col>
                    <v-col cols="6" class="pb-0 pt-0 pl-10 mt-0">
                      <v-checkbox class="mt-2" v-model="formData.isShowMeterName" outlined
                        :label="$t('meter.show_meter_name_in_detail_if_have')" hide-details>
                      </v-checkbox>
                    </v-col>
                  </template>
                </v-row>
                <v-row class="px-5 pb-0">
                  <v-col cols="12" class="pt-0 pb-0"><b> {{ $t('receipt.title') }}</b></v-col>
                  <v-col cols="6" class="py-1 ps-4">
                    <v-checkbox class="mt-2" v-model="formData.isGroupingItemsReceipt"
                      :disabled="formData.isShowDetailReceipt" outlined :label="$t('invoice.combine_into_one_list')"
                      hide-details>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="6" class="py-1 ps-4">
                    <v-checkbox class="mt-2" v-model="formData.isShowDetailReceipt"
                      :disabled="formData.isGroupingItemsReceipt" outlined :label="$t('invoice.show_detail_in_invoice')"
                      hide-details>
                    </v-checkbox>
                  </v-col>
                  <template v-if="formData.isShowDetailReceipt && formData.type == 'facility'">
                    <v-col cols="6"> </v-col>
                    <v-col cols="6" class="pb-0 pt-0 pl-10 mt-0">
                      <v-checkbox class="mt-2" v-model="formData.isShowMeterNameReceipt" outlined
                        :label="$t('meter.show_meter_name_in_detail_if_have')" hide-details>
                      </v-checkbox>
                    </v-col>
                  </template>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header class="acc-header">{{ $t('account.setting_accounting_code') }} <span
                  class="acc-header-detail">({{ $t('account.use_connect_erp') }})</span></v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="px-5">
                  <v-col cols="4" class="py-1">
                    <span>{{ $t('accounting_product.code') }} 1</span>
                    <v-text-field v-model="formData.code" outlined dense hide-details
                      :placeholder="$t('accounting_product.code') + ' 1'">
                    </v-text-field>
                  </v-col>
                  <v-col cols="4" class="py-1">
                    <span>{{ $t('accounting_product.code') }} 2</span>
                    <v-text-field v-model="formData.code2" outlined dense hide-details
                      :placeholder="$t('accounting_product.code') + ' 2'">
                    </v-text-field>
                  </v-col>
                  <v-col cols="4" class="py-1">
                    <span>{{ $t('accounting_product.code') }} 3</span>
                    <v-text-field v-model="formData.code3" outlined dense hide-details
                      :placeholder="$t('accounting_product.code') + ' 3'">
                    </v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <span>Dist Code</span>
                    <v-text-field v-model="formData.distCode" outlined dense hide-details placeholder="Dist Code">
                    </v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <span>{{ $t('accounting_product.unit_code') }}</span>
                    <v-text-field v-model="formData.unitCode" outlined dense hide-details
                      :placeholder="$t('accounting_product.unit_code')">
                    </v-text-field>
                  </v-col>
                  <v-col cols="4" class="align-content-center">
                    <v-checkbox v-model="formData.isMeterMonth" outlined dense hide-details
                      :label="$t('payment.previous_month_accounting')">
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-6">
          <v-spacer></v-spacer>
          <v-btn color="success" type="submit" elevation="0" :disabled="isLoading">
            <v-icon left>mdi-content-save</v-icon>{{ $t('save') }}
          </v-btn>
          <v-btn color="error" elevation="0" @click="dismiss()" :disabled="isLoading">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: "AccountingProductManageDialog",
  props: {
    value: Boolean, // v-model from root,
    projectId: String,
    product: Object
  },
  computed: {
    accountingProductManageDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
  },
  watch: {
    value(value) {
      if (value) {
        this.prepareFormData();
      }
    },
    formData: {
      handler(formData) {
        // if (formData.type == "facility" && !this.product) {
        //   // this.formData.isGroupingItems = false
        //   this.formData.isShowDetail = true;
        // } else {
        //   this.formData.isShowDetail = false;
        // }
      },
      deep: true
    }
  },
  data() {
    return {
      rules: {
        required: accountingProductManageDialog =>
          !!accountingProductManageDialog || this.$t('validate.please_input_data')
      },
      panel: [0],
      typeOptions: [],
      subTypeOptions: [],
      vatOptions: [],
      taxWithheldOptions: [],
      formData: {
        projectId: this.projectId,
        internalId: "",
        name: "",
        type: "",
        subType: "",
        sellVatType: 1,
        unit: "",
        unitCode: "",
        isMeterMonth: false,
        isGroupingItems: true,
        isShowDetail: false,
        isShowMeterName: false,
        isGroupingItemsReceipt: true,
        isShowDetailReceipt: false,
        isShowMeterNameReceipt: false
      },
      isLoading: false,
      isError: false,
      isSuccess: false,
      isAccountChartDialog: false
    };
  },
  created() {
    this.typeOptions = [
      {
        name: this.$t('accounting_product.type.rental'),
        value: "rental"
      },
      {
        name: this.$t('accounting_product.type.service'),
        value: "service"
      },
      {
        name: this.$t('accounting_product.type.facility'),
        value: "facility"
      },
      {
        name: this.$t('accounting_product.type.deposit'),
        value: "deposit"
      },
      {
        name: this.$t('accounting_product.type.discount'),
        value: "discount"
      },
      {
        name: this.$t('accounting_product.type.penalty'),
        value: "penalty"
      }
    ];

    this.subTypeOptions = [
      {
        name: this.$t('accounting_product.sub_type.water'),
        value: "water"
      },
      {
        name: this.$t('accounting_product.sub_type.elec'),
        value: "elec"
      }
    ];

    this.vatOptions = [
      {
        name: `VAT ${this.$globalVatPercent}%`,
        value: 1
      },
      {
        name: "VAT 0%",
        value: 2
      },
      {
        name: this.$t('tax.tax_exempt'),
        value: 3
      }
    ];

    this.taxWithheldOptions = [
      {
        name: this.$t('no'),
        value: 0
      },
      {
        name: "0.75%",
        value: 0.75
      },
      {
        name: "1%",
        value: 1
      },
      {
        name: "1.5%",
        value: 1.5
      },
      {
        name: "2%",
        value: 2
      },
      {
        name: "3%",
        value: 3
      },
      {
        name: "5%",
        value: 5
      },
      {
        name: "10%",
        value: 10
      },
      {
        name: "15%",
        value: 15
      }
    ];
  },
  methods: {
    dismiss() {
      this.$emit("input", false);
    },
    prepareFormData() {
      if (this.$refs.form) this.$refs.form.resetValidation();
      if (this.product) {
        this.formData = {
          id: this.product.objectId,
          code: this.product.code,
          code2: this.product.code2,
          code3: this.product.code3,
          name: this.product.name,
          distCode: this.product.distCode,
          type: this.product.type,
          subType: this.product.subType,
          sellVatType: this.product.sellVatType,
          unit: this.product.unit,
          unitCode: this.product.unitCode,
          isMeterMonth: this.product.isMeterMonth || false,
          whtPercent: this.product.whtPercent || 0,
          isGroupingItems: this.product.isGroupingItems ? true : false,
          isShowDetail: !this.product.isGroupingItems && this.product.isShowDetail ? true : false,
          isShowMeterName: this.product.isShowDetail && this.product.isShowMeterName ? true : false,
          isGroupingItemsReceipt: this.product.isGroupingItemsReceipt ? true : false,
          isShowDetailReceipt: !this.product.isGroupingItemsReceipt && this.product.isShowDetailReceipt ? true : false,
          isShowMeterNameReceipt: this.product.isShowDetailReceipt && this.product.isShowMeterNameReceipt ? true : false
        };
      } else {
        this.formData = {
          projectId: this.projectId,
          code: "",
          code2: "",
          code3: "",
          name: "",
          distCode: "",
          type: "",
          subType: "",
          sellVatType: 1,
          unit: "",
          unitCode: "",
          isMeterMonth: false,
          whtPercent: 0,
          isGroupingItems: true,
          isShowDetail: false,
          isShowMeterName: false,
          isGroupingItemsReceipt: true,
          isShowDetailReceipt: false,
          isShowMeterNameReceipt: false
        };
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          let data;
          if (this.formData.id) {
            data = await this.$store.dispatch(
              "accountingProducts/updateAccountingProduct",
              this.formData
            );
          } else {
            data = await this.$store.dispatch(
              "accountingProducts/createAccountingProduct",
              this.formData
            );
          }
          this.isLoading = false;
          this.isSuccess = true;
          this.$emit("onSaveSuccess", data);
          this.$emit("input", false);
        } catch (error) {
          this.isLoading = false;
          this.$emit("onError", error);
          this.$emit("input", false);
        }
      }
    }
  }
};
</script>

<style lang="scss">
.acc-header {
  font-size: 15px;
  font-weight: bold;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #000000de;

  .acc-header-detail {
    font-weight: 400;
    padding-left: 5px;
  }
}
</style>
